import { observer } from "mobx-react-lite";
import React from "react";
import { Container, Grid, Header, Table } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { useStore } from "../../../app/stores/store";
import PageHeader from "../../../app/layout/PageHeader";
import { InventoryOrderListReportDto } from "../../../app/models/inventoryReports";

interface Props {
  startDate: Date;
  endDate: Date;
}

export default observer(function InventoryOrderListPrint({
  startDate,
  endDate,
}: Props) {
  const { t } = useTranslation(["common", "reports"]);

  const { inventoryOrderListReportStore } = useStore();
  const { groupedInventoryOrderListReport } = inventoryOrderListReportStore;

  return (
    <>
      <Container className="page">
        <Grid stackable columns={2} className="headerPrint">
          <Grid.Row>
            <Grid.Column>
              <PageHeader
                header={`${t("report", { ns: "reports" })}: ${t("order_list", {
                  ns: "reports",
                })}`}
                type="h2"
                divider={false}
                getAlerts={true}
                addTitle={true}
              />
            </Grid.Column>
            <Grid.Column>
              <Header
                content={`${format(new Date(), "PP")}`}
                as="h2"
                textAlign="right"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {groupedInventoryOrderListReport &&
          groupedInventoryOrderListReport.length > 0 && (
            <Table striped unstackable className="dnxTable">
              {groupedInventoryOrderListReport.map(
                ([group, items], groupIndex) => (
                  <>
                    <Table.Body>
                      <Table.Row key={groupIndex}>
                        <Table.Cell
                          colSpan={16}
                          textAlign="left"
                          className="terms_bold"
                        >
                          {group}
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>
                          {t("part_number", { ns: "reports" })}
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                          {t("description", { ns: "common" })}
                        </Table.HeaderCell>
                        <Table.HeaderCell></Table.HeaderCell>
                        <Table.HeaderCell textAlign="right"></Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">
                          {t("reorder_lvl", { ns: "reports" })}
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="right">
                          {t("current_qty", { ns: "reports" })}
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {items.map((itm: InventoryOrderListReportDto, itmIdx) => (
                        <Table.Row key={itm.id}>
                          <Table.Cell
                            data-label={`${t("part_number", {
                              ns: "reports",
                            })}:`}
                          >
                            {itm.partNumber}
                          </Table.Cell>
                          <Table.Cell
                            data-label={`${t("description", {
                              ns: "common",
                            })}:`}
                          >
                            {itm.partDescription}
                          </Table.Cell>
                          <Table.Cell></Table.Cell>
                          <Table.Cell></Table.Cell>
                          <Table.Cell
                            textAlign="center"
                            data-label={`${t("reorder_lvl", {
                              ns: "reports",
                            })}:`}
                          >
                            {itm.reOrderLevel}
                          </Table.Cell>
                          <Table.Cell
                            data-label={`${t("current_qty", {
                              ns: "reports",
                            })}:`}
                            textAlign="right"
                          >
                            {itm.currentQuantity}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                      <Table.Row className="noBackground">
                        <Table.Cell colSpan={11}></Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </>
                )
              )}
            </Table>
          )}
      </Container>
    </>
  );
});
